function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _window_themis;
import appxLoader from "../loader/appxLoader";
import wxAppLoader from "../loader/wxAppLoader";
import windVaneLoader from "../loader/windVaneLoader";
import antLoader from "../loader/antLoader";
import ksminiAppLoader from "../loader/ksminiAppLoader";
import ttminiAppLoader from "../loader/ttminiAppLoader";
import dingdingLoader from "../loader/dingdingLoader";
import xhsminiAppLoader from "../loader/xhsminiAppLoader";
import { isBrowser } from "./ssr-utils";
export { notSupportForPromise, notSupportForCallback, notSupportForObjForm, notSupportForVariable } from "./notSupport";
export var noop = function noop(e) {
    if (e) {
        console.log(e);
    }
};
export var StatusCodes = /*#__PURE__*/ function(StatusCodes) {
    StatusCodes[StatusCodes["Success"] = 0] = "Success";
    StatusCodes[StatusCodes["Executing"] = 1] = "Executing";
    StatusCodes[StatusCodes["None"] = 2] = "None";
    StatusCodes[StatusCodes["Finish"] = 99] = "Finish";
    StatusCodes[StatusCodes["ServerAPINotFound"] = 150] = "ServerAPINotFound";
    StatusCodes[StatusCodes["ServerDataNotFound"] = 151] = "ServerDataNotFound";
    StatusCodes[StatusCodes["NonMainThread"] = 200] = "NonMainThread";
    StatusCodes[StatusCodes["AbilityNotFound"] = 404] = "AbilityNotFound";
    StatusCodes[StatusCodes["APINotFound"] = 405] = "APINotFound";
    StatusCodes[StatusCodes["AbilityInternalError"] = 499] = "AbilityInternalError";
    StatusCodes[StatusCodes["ParametersNotCorrect"] = 500] = "ParametersNotCorrect";
    StatusCodes[StatusCodes["BizDefaultError"] = 1000] = "BizDefaultError";
    return StatusCodes;
}({});
export var one = function(event, handler) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var once = function(e) {
        handler(e);
        target.removeEventListener(event, once, options);
    };
    return target.addEventListener(event, once, options);
};
export var replace = function(className) {
    var tpl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var clsArr = className.split(' ');
    var selectorCls = clsArr[0];
    var ele = document.querySelector(".".concat(selectorCls));
    if (!ele) {
        return null;
    }
    ele.innerHTML = tpl;
    ele.className = "".concat(className, " show");
    return ele;
};
export var create = function(className) {
    var tpl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    var ele = document.createElement('div');
    ele.className = "".concat(className, " show");
    ele.innerHTML = tpl;
    return ele;
};
export var notify = function() {
    var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'dynamic script loaded';
    return console.log(msg);
};
export function callWxMiniApp(methodName, options) {
    return new Promise(function(resolve, reject) {
        wxAppLoader(function(wx) {
            try {
                wx && wx.miniProgram[methodName] && wx.miniProgram[methodName](options);
                resolve({
                    errorCode: 0
                });
            } catch (err) {
                reject(err);
            }
        });
    });
}
/**
 * 支付宝影城渠道
 * @param methodName 方法名
 * @param options
 * @returns
 */ export function callAppx(methodName, options) {
    return new Promise(function(resolve, reject) {
        appxLoader(function(my) {
            try {
                my[methodName] && my[methodName](options);
                resolve({
                    errorCode: 0
                });
            } catch (err) {
                reject(err);
            }
        });
    });
}
var transformCallbackParams = function(originCallbackParams) {
    var callbackParams = Object.assign({}, originCallbackParams, {
        originStatusCode: originCallbackParams === null || originCallbackParams === undefined ? undefined : originCallbackParams.statusCode
    });
    // 100 以下的 statusCode 统一处理成 StatusCodes.Success，方便业务判断。
    // 99 作为持续回调设计给引擎/容器释放 JSValue 防止内存泄漏，不需要透出给前端业务开发者。
    if ((originCallbackParams === null || originCallbackParams === undefined ? undefined : originCallbackParams.statusCode) < 99) {
        callbackParams.statusCode = 0;
    }
    return callbackParams;
};
var callMegaBridge = function(ability, api) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, callback = arguments.length > 3 ? arguments[3] : void 0;
    var _window___megability_bridge__;
    return (_window___megability_bridge__ = window.__megability_bridge__) === null || _window___megability_bridge__ === void 0 ? void 0 : _window___megability_bridge__.asyncCall(ability, api, params, function(callbackParams) {
        callback && callback(callbackParams);
    });
};
var callMegaBridgeSync = function(ability, api) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _window___megability_bridge__;
    var res = (_window___megability_bridge__ = window.__megability_bridge__) === null || _window___megability_bridge__ === void 0 ? void 0 : _window___megability_bridge__.syncCall(ability, api, params);
    return res;
};
export var callThemisSync = function(ability) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, preprocessor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(res) {
        return res;
    };
    var api = ability.split('.');
    var className = api[0], methodName = api[1];
    var _result = callMegaBridgeSync(className, methodName, params);
    var transformedCallbackParams = transformCallbackParams(_result) || {};
    return preprocessor(_object_spread({
        statusCode: transformedCallbackParams.statusCode
    }, transformedCallbackParams === null || transformedCallbackParams === void 0 ? void 0 : transformedCallbackParams.data));
};
export var callThemis = function(ability) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, preprocessor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(res) {
        return res;
    };
    var api = ability.split('.');
    var className = api[0], methodName = api[1];
    return new Promise(function(resolve, reject) {
        var isFirst = true;
        var eventMap = {};
        Object.keys(params).forEach(function(key) {
            var param = params[key];
            if (typeof param === 'function') {
                eventMap[key.toLowerCase()] = param;
            }
        });
        callMegaBridge(className, methodName, params, function(callbackParams) {
            var transformedCallbackParams = transformCallbackParams(callbackParams) || {};
            var result = preprocessor(_object_spread({
                statusCode: transformedCallbackParams.statusCode
            }, transformedCallbackParams === null || transformedCallbackParams === void 0 ? void 0 : transformedCallbackParams.data));
            console.log('ability---->', ability);
            console.log('api---->', api);
            console.log('params---->', JSON.stringify(params));
            console.log('callbackParams---->', JSON.stringify(callbackParams));
            console.log('result---->', JSON.stringify(result));
            // 第一次结果对应客户端中的 return，属于调用是否成功。
            if (isFirst) {
                if (transformedCallbackParams.statusCode === 0) {
                    resolve((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' ? _object_spread({
                        errorCode: 0
                    }, result) : result);
                } else {
                    reject((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' ? _object_spread({
                        errorCode: 1
                    }, transformedCallbackParams || {}) : result);
                }
                isFirst = false;
            }
            // statusCode 不为 None 才处理事件。
            if (transformedCallbackParams.originStatusCode !== 2) {
                // 处理事件。
                if (transformedCallbackParams.statusCode !== 0) {
                    // statusCode > 100 直接抛出异常事件。
                    // 对onError做兼容，在API失败的时候也能走到失败回调
                    var errorHandler = eventMap['onerror'];
                    if (errorHandler && typeof errorHandler === 'function') {
                        errorHandler(callbackParams);
                    } else {
                        reject((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' ? _object_spread({
                            errorCode: 1
                        }, transformedCallbackParams || {}) : result);
                    }
                } else if (transformedCallbackParams.type) {
                    var type = transformedCallbackParams.type;
                    // 没有 on 的时候补齐 on，大小写无感。
                    if (!/^on/.test(type)) {
                        type = 'on'.concat(type.toLowerCase());
                    } else {
                        type = type.toLowerCase();
                    }
                    var func = eventMap[type];
                    if (typeof func === 'function') {
                        func(result || {});
                    }
                }
            }
        });
    });
};
/**
 *
 * @param methodName 客户端方法名 CLASS + METHOD
 * @param options 传递给客户端的参数
 * @param successPreprocessor 成功情况下对客户端返回值的处理hook
 * @param failPreprocessor 失败情况下对客户端返回值的处理hook
 * @returns Promise
 */ export var callWindVane = function(methodName) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, successPreprocessor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(res) {
        return res;
    }, failPreprocessor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function(res) {
        return res;
    };
    return new Promise(function(resolve, reject) {
        windVaneLoader(function(param) {
            var nativeCall = param.nativeCall;
            nativeCall(methodName, options, function() {
                var res = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var result = typeof successPreprocessor === 'function' ? successPreprocessor(res) : res;
                if ((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' && result.errorCode === 1) {
                    reject(result);
                } else {
                    resolve((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' ? _object_spread({
                        errorCode: 0
                    }, result) : result);
                }
            }, function() {
                var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var errRes = typeof failPreprocessor === 'function' ? failPreprocessor(error) : error;
                reject((typeof errRes === "undefined" ? "undefined" : _type_of(errRes)) === 'object' ? _object_spread({
                    errorCode: 1
                }, errRes) : errRes);
            });
        });
    });
};
/**
 *
 * @param namespace 命名空间
 * @param feature 功能
 * @param method 方法
 * @param options 入参对象
 * @param successPreprocessor 成功情况下处理返回值
 * @param failPreprocessor 失败情况下处理返回值
 * @returns Promise
 */ export function callDD(namespace, feature, method) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, successPreprocessor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function(res) {
        return res;
    }, failPreprocessor = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function(res) {
        return res;
    };
    return new Promise(function(resolve, reject) {
        try {
            dingdingLoader(function(dd) {
                var _dd_namespace_feature, _dd_namespace;
                var ddFn = dd === null || dd === void 0 ? void 0 : (_dd_namespace = dd[namespace]) === null || _dd_namespace === void 0 ? void 0 : (_dd_namespace_feature = _dd_namespace[feature]) === null || _dd_namespace_feature === void 0 ? void 0 : _dd_namespace_feature[method];
                if (typeof ddFn === 'function') {
                    ddFn(_object_spread_props(_object_spread({}, options), {
                        onSuccess: function(result) {
                            var res = successPreprocessor(result);
                            if ((typeof res === "undefined" ? "undefined" : _type_of(res)) === 'object' && res.errorCode === 1) {
                                reject(res);
                            } else {
                                resolve((typeof res === "undefined" ? "undefined" : _type_of(res)) === 'object' ? _object_spread({
                                    errorCode: 0
                                }, res) : res);
                            }
                        },
                        onFail: function(error) {
                            var errRes = typeof failPreprocessor === 'function' ? failPreprocessor(error) : error;
                            reject((typeof errRes === "undefined" ? "undefined" : _type_of(errRes)) === 'object' ? _object_spread({
                                errorCode: 1
                            }, errRes) : errRes);
                        }
                    }));
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * @param methodName 调用nebula容器的方法名
 * @param options 入参对象
 * @param preprocessor  成功情况下处理返回值的hook函数
 * @returns
 */ export function callNebula(methodName) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, preprocessor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(res) {
        return res;
    };
    return new Promise(function(resolve, reject) {
        antLoader(function(AlipayJSBridge) {
            AlipayJSBridge.call(methodName, options, function(res) {
                if (res.error && res.error + '' !== '0' || (res === null || res === void 0 ? void 0 : res.errorMessage)) {
                    reject({
                        errorCode: 1,
                        errorMessage: res.errorMessage
                    });
                    return;
                }
                var result = preprocessor(res);
                resolve((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object' ? _object_spread({
                    errorCode: 0
                }, result) : result);
            });
        });
    });
}
export function callKsMiniApp(methodName, options) {
    return new Promise(function(resolve, reject) {
        ksminiAppLoader(function() {
            try {
                window.ks && window.ks[methodName] && window.ks[methodName](options);
                resolve({
                    errorCode: 0
                });
            } catch (error) {
                reject(error);
            }
        });
    });
}
export function callTtMiniApp(methodName, options) {
    return new Promise(function(resolve, reject) {
        ttminiAppLoader(function() {
            try {
                window.tt && window.tt.miniProgram && window.tt.miniProgram[methodName] && window.tt.miniProgram[methodName](options);
                resolve({
                    errorCode: 0
                });
            } catch (error) {
                reject(error);
            }
        });
    });
}
export function callXhsMiniProgram(methodName, options) {
    return new Promise(function(resolve, reject) {
        xhsminiAppLoader(function() {
            try {
                window.xhs && window.xhs.miniProgram && window.xhs.miniProgram[methodName] && window.xhs.miniProgram[methodName](options);
                resolve({
                    errorCode: 0
                });
            } catch (error) {
                reject(error);
            }
        });
    });
}
export var parse = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _window_location, _window;
        return (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.search;
    }();
    var input = (search === null || search === void 0 ? void 0 : search.indexOf('?')) !== -1 ? search === null || search === void 0 ? void 0 : search.split('?')[1] : search;
    if (!input) {
        return {};
    }
    var searchParams = new URLSearchParams(input);
    if (typeof Object.fromEntries === 'function') {
        return Object.fromEntries(searchParams);
    }
    var output = {};
    searchParams.forEach(function(value, key) {
        output[key] = value === undefined ? '' : value;
    });
    return output;
};
export var formatReturnCode = function(code) {
    var map = {
        '10': 10003,
        '11': 10002,
        '12': 10011,
        '13': 10001
    };
    return map[code] || code;
};
export var handleCalendarResult = function(res) {
    if ((res === null || res === void 0 ? void 0 : res.success) + '' === 'true') {
        return {
            result: true,
            errorCode: 0
        };
    } else if (res.error) {
        return {
            result: false,
            errorCode: formatReturnCode(res.error)
        };
    }
    return {
        result: false,
        errorCode: 1
    };
};
export function canIUseThemisBridge(api) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!window.__megability_bridge__) {
        return false;
    }
    var ABILITY_NAME = 'ability';
    var ACTIONS = {
        AVAILABLE: 'available'
    };
    var _api_split = _sliced_to_array(api.split('.'), 2), tmp = _api_split[0], ability = tmp === void 0 ? '' : tmp, tmp1 = _api_split[1], action = tmp1 === void 0 ? '' : tmp1;
    // 注册表映射首字母小写，通过转换匹配 Toast.show 这样的传参。
    if (ability && ability.length) {
        ability = ability.charAt(0).toLowerCase() + ability.slice(1);
    }
    if (action && action.charAt(0)) {
        action = action.charAt(0).toLowerCase() + action.slice(1);
    }
    var res = window.__megability_bridge__.syncCall(ABILITY_NAME, ACTIONS.AVAILABLE, _object_spread({
        ability: ability,
        api: action
    }, params));
    return res && res.statusCode === 0 && res.type === 'YES';
}
/** 是否在手淘关联了uniapp的轻应用环境下 */ export var isInUniapp = isBrowser() && ((_window_themis = window.themis) === null || _window_themis === void 0 ? void 0 : _window_themis.appContext.solution) === 'UNIAPP';
